export default __webpack_public_path__ + "static/media/Selo-M-1.6842830a.png";